module.exports = __webpack_public_path__ + "static/johanna-8f61024a180bbc184c1df0f5140ded61.jpg";